"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOsReleaseStatic = void 0;
const static_1 = require("./static");
Object.defineProperty(exports, "getOsReleaseStatic", { enumerable: true, get: function () { return static_1.getOsRelease; } });
//# sourceMappingURL=index.js.map